import { paymentProviderZodSchema } from "@@/shared/payments/payment-providers";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateWordSlug } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { signatureFactory } from "../../signature-factory";
import type {
    _OrderEventBaseFactoryParams} from "../_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "../_order-base.event";
import { orderEventIdZodSchema } from "../_order-event-id";

const orderEventPendingPaymentConfirmationZodSchema =
    _orderEventBaseZodObject.merge(
        z.object({
            type: z.literal("PENDING_PAYMENT_CONFIRMATION"),
            createdBy: userIdZodSchema.or(z.string()),
            paymentProvider: paymentProviderZodSchema,
            paymentFor: z.object({
                orderEventId: orderEventIdZodSchema,
            }),
        }),
    );
type OrderPendingPaymentConfirmationEvent = z.infer<
    typeof orderEventPendingPaymentConfirmationZodSchema
>;

type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderPendingPaymentConfirmationEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;

type Params = Except<FactoryParams, "signature"> & { intentId?: string };

const orderEventPendingPaymentConfirmationFactory = (
    params: Params,
): OrderPendingPaymentConfirmationEvent => ({
    ..._orderEventBaseFactory({
        ...params,
        signature: signatureFactory(
            params.orderId,
            "PENDING_PAYMENT_CONFIRMATION",
            params.intentId
                ? [params.intentId, generateWordSlug()]
                : [generateWordSlug()],
        ),
    }),

    type: "PENDING_PAYMENT_CONFIRMATION",
    createdBy: params.createdBy,
    paymentProvider: params.paymentProvider,
    paymentFor: params.paymentFor,
});

export {
    orderEventPendingPaymentConfirmationFactory,
    orderEventPendingPaymentConfirmationZodSchema,
};
export type { OrderPendingPaymentConfirmationEvent };
